/* Rudi / Adam, 2026-10-06: "the main header video feels a bit low quality."
   The homepage clips were 480p re-encodes. They now stream the 1080p
   originals Shopify already holds, as HLS, so each visitor gets the best
   quality their connection and tile size can carry.

   ejhSetSrc(video, value) replaces every `video.src = value` in the
   homepage scripts. value is "hls.m3u8^fallback.mp4" or a plain URL.
     - plain URL: set as before.
     - Safari/iOS: native HLS, set directly.
     - Chrome/Firefox/Edge: hls.js (assets/hls.light.min.js), loaded once,
       on first use. Attaching waits a tick so the caller's own v.load()
       runs first and cannot reset the stream; a play() asked for before
       the stream is ready is remembered and honoured when it is.
     - no MediaSource, or hls.js fails: the 720p MP4. */
(function () {
  var HLS_URL = (document.currentScript && document.currentScript.getAttribute('data-hls')) || '';
  var proto = window.HTMLMediaElement && HTMLMediaElement.prototype;
  var hlsReady = null;

  function loadHls() {
    if (window.Hls) return Promise.resolve(window.Hls);
    if (hlsReady) return hlsReady;
    hlsReady = new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = HLS_URL; s.async = true;
      s.onload = function () { resolve(window.Hls || null); };
      s.onerror = function () { resolve(null); };
      document.head.appendChild(s);
    });
    return hlsReady;
  }

  function hold(v) {
    if (v.__ejhHeld) return;
    v.__ejhHeld = true;
    v.play = function () {
      if (v.__ejhPending) { v.__ejhWant = true; return Promise.resolve(); }
      return proto.play.call(v);
    };
    v.pause = function () { v.__ejhWant = false; return proto.pause.call(v); };
  }

  function release(v) {
    v.__ejhPending = false;
    if (v.__ejhWant) { var p = proto.play.call(v); if (p && p.catch) p.catch(function () {}); }
  }

  window.ejhSetSrc = function (v, raw) {
    if (!v) return;
    raw = String(raw || '');
    if (v.__ejhRaw === raw) return;
    v.__ejhRaw = raw;
    var parts = raw.split('^'), hls = parts[0], mp4 = parts[1] || '';
    if (!/\.m3u8(\?|$)/.test(hls)) { v.src = hls; return; }
    if (v.canPlayType('application/vnd.apple.mpegurl')) { v.src = hls; return; }
    if (!window.MediaSource || !HLS_URL) { v.src = mp4 || hls; return; }

    hold(v);
    v.__ejhPending = true;
    loadHls().then(function (Hls) {
      window.setTimeout(function () {
        if (v.__ejhRaw !== raw) return;
        if (!Hls || !Hls.isSupported()) { v.__ejhPending = false; v.src = mp4; release(v); return; }
        if (v.__ejhHls) { try { v.__ejhHls.destroy(); } catch (e) {} }
        var h = new Hls({ capLevelToPlayerSize: true, startLevel: -1, maxBufferLength: 20 });
        v.__ejhHls = h;
        h.on(Hls.Events.MANIFEST_PARSED, function () { release(v); });
        h.on(Hls.Events.ERROR, function (e, d) {
          if (!d || !d.fatal) return;
          try { h.destroy(); } catch (x) {}
          v.__ejhHls = null;
          if (mp4) { v.src = mp4; release(v); }
        });
        h.loadSource(hls);
        h.attachMedia(v);
      }, 0);
    });
  };
})();
